import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class TextField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      focus: false,
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    inputRef: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
  };

  static defaultProps = {
    type: 'text',
    label: null,
    inputRef: () => null,
    className: 'normal-input',
    disabled: false,
    required: false
  };

  onFocus() {
    this.setState({
      focus: true,
    });
  }

  onBlur() {
    this.setState({
      focus: false,
    });
  }

  render() {
    const { id, name, type, label, value, onChange, inputRef, disabled, required } = this.props;
    const hasLabel = !!label;
    let className = `input-field field-type-${type} ${
      hasLabel ? 'input-field-label' : ''
    }`;

    className += ' ' + this.props.className;

    return (
      <div className={classNames(className, {'focus': this.state.focus, 'empty': !value, 'disabled': disabled, 'required': required})}>
        {hasLabel && (
          <label htmlFor={id}>
            { label } { required ? '*' : ''}
          </label>
        )}
        <input
          ref={inputRef}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          id={id}
          name={name}
          type={type}
          value={value ? value : ''}
          onChange={onChange}
          disabled={disabled}
          required={required}
        />
      </div>
    );
  }
}

export default TextField;
